"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_FAUCET_NETWORKS = void 0;
const network_1 = require("../network");
exports.SUPPORTED_FAUCET_NETWORKS = {
    [network_1.NetworkNames.Etherspot]: true,
    [network_1.NetworkNames.LocalA]: true,
    [network_1.NetworkNames.LocalB]: true,
    [network_1.NetworkNames.LocalH]: true,
};
